<template>
  <ProSpaceGeoLayout class="adjustments-outlets-grid address-program" style="margin-top: 15px;">
    <template #top>
      <ProSpaceFilterPanel
        @apply="submitFilter"
        ref="filter-panel"
        class="adjustments-outlets-grid__filter"
        :noMountedRequest="true"
        :excludedFilters="['marsPeriodId']"
        :oneValueFilters="['marsPeriodId']"
      />
    </template>
    <template #center>
      <ProSpaceMainGrid
        ref="grid"
        :service="service"
        class="address-program__main-grid adjustments-outlets-grid__main-grid"
        @selected-change="selectedHandler"
        :getMethod="getMethod"
        :default-filter="defaultFilter"
        selectionMode="single"
        :resizable="false"
        :noMountedRequest="true"
        :defaultSortField="selectCurrentSorting"
      >
        <template #columns>
          <Column
            field="outletId"
            :header="$t('addressProgramOutlet')"
            sortable
            class="address-program__column-store"
            style="
              max-width: 12dvw;
              height: auto !important;
            "
            headerStyle="max-width: 12.5dvw; padding-left: 0px;"
          >
            <template #body="field">
              <store-column
                v-if="field.data"
                :data="field.data"
                :status="getStatus(field.data.status)"
                :isStatusDisplay="checkAccess('adjustments-orderStatus')"
                class="store-column__single"
              />
            </template>
          </Column>
          <Column
            class="address-program__bordered-column address-program__sorting-table-header"
            :field="selectCurrentSorting === 'outletId' ? sortingOptions[0]?.value : selectCurrentSorting"
            :header="`${$t('addressProgramParameters')} ${currentSortingLabel ? '(' + currentSortingLabel + ')' : ''}`"
            sortable
            style="
              border-left: 1px solid var(--prospace-ui-border-color);
            "
          >
            <template #header="field">
              <ProSpaceDropdown
                v-model="selectCurrentSorting"
                class="address-program__dropdown"
                :options="sortingOptions"
                :inputStyle="{display: 'none'}"
                propLabel="label"
                propValue="value"
                :dropdownIcon="['prospace-icon icon-sliders', { 'prospace-icon--secondary': dropdownVisible }]"
                appendTo=".address-program__dropdown"
                filterIcon="icon-search prospace-icon"
                :filterPlaceholder="$t('searchTxt')"
                scrollHeight="245px"
                filter
                @hide="dropdownVisible = false"
                @show="dropdownVisible = true"
              >
              </ProSpaceDropdown>
            </template>
            <template #body="field">
              <multi-column
                v-if="field.data"
                :columns="6"
                :data="getParamsColumns(field.data)"
              />
            </template>
          </Column>
          <Column
            class="address-program__bordered-column"
            field="frequencyPlan"
            :header="'KPI'"
            sortable
            style="max-width: 18dvw"
            headerStyle="border-right: none !important;"
          >
            <template #body="field">
              <multi-column
                v-if="field.data"
                :columns="3"
                :data="getKpiColumns(field.data)"
              />
            </template>
          </Column>
        </template>
        <template #empty>
          <ProSpaceEmptyGrid
            icon="error-message"
            :title="$t('noDataTitle')"
            :text="$t('noDataTxt')"
          />
        </template>
      </ProSpaceMainGrid>
    </template>
  </ProSpaceGeoLayout>
</template>
<script>
import {
  ProSpaceFilterPanel,
  ProSpaceCustomFilterPanel,
  ProSpaceMultiSelect,
  ProSpaceMainGrid,
  ProSpaceDots,
  ProSpaceModal,
  ProSpaceGeoLayout,
  ProSpaceTopPanel,
  ProSpaceIconButton,
  ProSpaceIcon,
  ProSpaceButton,
  ProSpaceTableHeaderCell,
  ProSpaceDateColumn,
  ProSpaceDefaultTextColumn,
  ProSpaceEmptyGrid,
  ProSpaceTree,
  ProSpaceVLayout,
  ProSpaceHLayout,
  ProSpaceFilterContainsChips,
  ProSpaceFilterDatesRange,
  ProSpaceDropdown,
  ProSpaceTag,
} from "@prospace/prospace-components-library";
import formatDigit from "@prospace/prospace-components-library/src/lib-assets/mixins/digitFormatter";
import Column from "primevue/column";
import {AddressProgramOrderService} from "../../../services/AddressProgramOrderService";

import AddressProgramOrderPanel from "../../AddressProgramOrders/components/AddressProgramOrderPanel.vue";
const _ = require("lodash");
import { mapGetters } from "vuex";
import StoreColumn from "../../AddressProgramOrders/columns/storeColumn.vue";
import MultiColumn from "../../AddressProgramOrders/columns/multiColumn.vue";
import { queryBuilder } from "@prospace/prospace-components-library";
import sortingOptions from "../../AddressProgramOrders/sortingOptions";

export default {
  components: {
    StoreColumn,
    MultiColumn,
    AddressProgramOrderPanel,
    ProSpaceFilterPanel,
    ProSpaceCustomFilterPanel,
    ProSpaceMultiSelect,
    ProSpaceMainGrid,
    ProSpaceDots,
    ProSpaceModal,
    Column,
    ProSpaceGeoLayout,
    ProSpaceTopPanel,
    ProSpaceIconButton,
    ProSpaceIcon,
    ProSpaceButton,
    ProSpaceTableHeaderCell,
    ProSpaceDateColumn,
    ProSpaceDefaultTextColumn,
    ProSpaceEmptyGrid,
    ProSpaceTree,
    ProSpaceVLayout,
    ProSpaceHLayout,
    ProSpaceFilterContainsChips,
    ProSpaceFilterDatesRange,
    ProSpaceDropdown,
    ProSpaceTag,
  },
  props: {
    service: {
      type: Object,
      required: true
    },
    getMethod: {
      type: String,
      required: true
    },
    defaultFilter: {
      type: Object,
      required: false
    },
    checkAccess: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      queryBuilder,
      selectedModel: null,
      addressProgramOrderService: new AddressProgramOrderService(),
      sortingOptions: sortingOptions(this.$t),
      selectCurrentSorting: 'outletId',
      dropdownVisible: false,
      currentSortingLabel: this.$t("rsm"),
    };
  },
  watch: {
    selectCurrentSorting(val) {
      const option = this.sortingOptions.find(s => s.value === val);
      if (option) {
        this.currentSortingLabel = option.label;
      }
      this.dropdownVisible = false;
      this.$nextTick(() => {
        this.$refs.grid.getRecords(true)
      })
    }
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      currentPeriod: "marsPeriodStoreArchived/getMarsPeriod",
    }),
    gridData() {
      return this.addressProgramOrderService.transformer.gridData;
    },
  },
  methods: {
    formatDigit,
    getParamsColumns(data) {
      const {
        city, area, clusterValue, rsmValue, tdmValue, kaeValue,
        outletTypeValue, externalFormatValue, channelValue, narkaValue, sipChannelValue, externalCode,
        territoryCluster, tariffZone, skyline, agencyValue, coverage
      } = data
      const obj = [
        [
          { title: this.$t("city"), value: city },
          { title: this.$t("area"), value: area },
          { title: this.$t("cluster"), value: clusterValue },
          { title: this.$t("rsm"), value: rsmValue },
          { title: this.$t("tdm"), value: tdmValue },
          { title: this.$t("kae"), value: kaeValue },
        ],
        [
          { title: this.$t("outletType"), value: outletTypeValue },
          { title: this.$t("externalFormat"), value: externalFormatValue },
          { title: this.$t("channel"), value: channelValue },
          { title: this.$t("narka"), value: narkaValue },
          { title: this.$t("sipChannel"), value: sipChannelValue },
          { title: this.$t("externalCode"), value: externalCode },
        ],
      ];

      const thirdRow = [];
      thirdRow.push({
        title: this.$t("territoryCluster"),
        value: territoryCluster,
      });
      thirdRow.push({ title: this.$t("tariffZone"), value: tariffZone });
      thirdRow.push({ title: this.$t("skyline"), value: skyline });
      if (this.checkAccess("agencyValue-row"))
        thirdRow.push({ title: this.$t("agency"), value: agencyValue });
      thirdRow.push({
        title: this.$t("coverage"),
        value: coverage ? this.$t("yes") : this.$t("no"),
      });
      obj.push(thirdRow);

      return obj;
    },
    getKpiColumns(data) {
      const {
        frequencyPlan, frequencyFact, timingPerVisitPlan, timingPerVisitFact, ratePerHourPlan, ratePerHourFact,
        osaPlan, osaFact, pssPlan, pssFact, tacticalTaskPlan, tacticalTaskFact,
        fteMerchPlan, fteMerchFact, totalSumPlan, totalSumFact
      } = data
      const addPercent = (string) => {
        if (string === 0) return 0
        return string ? `${string}%` : "";
      };
      const getPercentNumber = value => Number(parseFloat(value * 100).toFixed(2))
      const obj = [
        [
          {
            title: this.$t("addressProgramOrderFrequency"),
            value: formatDigit(frequencyPlan),
            fact: formatDigit(frequencyFact)
          },
          {
            title: this.$t("timingPerVisit"),
            value: formatDigit(timingPerVisitPlan),
            fact: formatDigit(timingPerVisitFact)
          },
          {
            title: this.$t("ratePerHour"),
            value: formatDigit(ratePerHourPlan),
            fact: formatDigit(ratePerHourFact)
          },
        ],
        [
          {
            title: this.$t("osa"),
            value: addPercent(formatDigit(getPercentNumber(osaPlan))),
            fact: addPercent(formatDigit(getPercentNumber(osaFact)))
          },
          {
            title: this.$t("pss"),
            value: addPercent(formatDigit(getPercentNumber(pssPlan))),
            fact: addPercent(formatDigit(getPercentNumber(pssFact)))
          },
          {
            title: this.$t("tacticalTask"),
            value: formatDigit(tacticalTaskPlan),
            fact: formatDigit(tacticalTaskFact)
          },
        ],
        [
          {
            title: this.$t("fteMerch"),
            value: formatDigit(fteMerchPlan),
            fact: formatDigit(fteMerchFact)
          },
          {
            title: this.$t("totalSum"),
            value: this.formatDigit(totalSumPlan),
            fact: this.formatDigit(totalSumFact)
          },
        ]
      ]
      return obj
    },
    submitFilter({ filter, search }) {
      if (Object.keys(this.currentPeriod).length > 0) {
        this.$refs.grid.submitFilter(filter, search);
      }
    },
    selectedHandler({data}) {
      this.$emit('onSelect', data)
    },
    getStatus(status) {
      if (!status) return;
      let type = "default";
      let text = "";
      switch (status) {
        case "plan":
          type = "info";
          text = this.$t("planStatus");
          break;
        case "draft":
          type = "draft";
          text = this.$t("draftStatus");
          break;
        case "planfact":
          type = "success";
          text = this.$t("planFactStatus");
          break;
      }
      return {
        text,
        type,
      };
    },
  },
  mounted() {
    this.$refs.grid.getRecords(true);
  },
}
</script>
<style lang="scss" scoped>
.adjustments-outlets-grid {
  .adjustments-outlets-grid__filter {
    display: none;
  }
  &__main-grid {
    :deep(.p-datatable .p-datatable-thead) {
      border-left: 1px solid var(--prospace-ui-border-color);
    }
    :deep(.p-datatable-tbody) {
      padding: 0 4px;
    }
  }
  :deep(.p-datatable .p-datatable-tbody > tr:not(.p-datatable-emptymessage) > td:last-child) {
    padding-left: 10px;
    padding-right: 10px;
    border-right: none !important;
  }
  :deep(.p-datatable .p-datatable-thead) {
    padding-left: 0 !important;
  }
  :deep(.p-selectable-row),
  :deep(.p-datatable .p-datatable-tbody > tr:not(.p-datatable-emptymessage)) {
    margin-top: 4px;
    margin-bottom: 4px;
  }
}
.address-program {
  :deep(.address-program__multiple-grid .p-datatable .p-datatable-thead > tr),
  :deep(.address-program__multiple-grid .p-datatable .p-datatable-tbody > tr) {
    padding-right: 0px;
    padding-left: 0px;
  }
  :deep(.address-program__multiple-grid .address-program__column-store) {
    min-width: 140px !important;
    padding-left: 0;
  }
  :deep(.address-program__multiple-grid .address-program__column-store + td) {
    min-width: 390px !important;
  }
  :deep(
      .address-program__multiple-grid .address-program__column-store + td + td
    ) {
    min-width: 190px !important;
  }
  :deep(.p-datatable .p-datatable-tbody > tr) {
    padding-right: 0px;
  }
  &__filters {
    :deep(.prospace-radio-button-secondary) {
      height: 40px;
    }
    :deep(.prospace-radio-button-secondary__header) {
      height: 100% !important;
    }
    &--disabled {
      :deep(.prospace-filter-panel__filters-container),
      :deep(.prospace-filter-panel__first-row) {
        display: none;
      }
    }
  }
  &__store-amount {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 16px;
    font-weight: 500;
    color: #fff;
    height: 40px;
    width: 40px;
    background: var(--prospace-chart-plan);
    border-radius: 3px;
  }
  &__grouping {
    &-apply-btn {
      color: #2196f3;
    }
  }
  &__green-button {
    background-color: #1abc9c;
  }
  :deep(.address-program__sorting-table-header .p-column-header-content) {
    width: 100%;
    justify-content: space-between;
  }
  :deep(.address-program__sorting-table-header .p-column-title) {
    margin-right: 5px;
    order: 1;
  }
  :deep(.address-program__sorting-table-header .p-sortable-column-icon) {
    margin-right: auto;
    order: 2;
  }
  &__sorting-table-header {
    border-left: 1px solid #E0E7F4; //TODO: move to lib
    border-right: 1px solid #E0E7F4; //TODO: move to lib
    .prospace-icon-button {
      order: 3;
    }
  }
  :deep(.address-program__dropdown .p-dropdown) {
    background: none;
    border: none;
    height: auto;
  }
  :deep(.address-program__dropdown .prospace-dropdown-panel) {
    width: 178px;
    position: absolute !important;
    right: 0 !important;
    left: auto !important;
    top: 24px !important;
  }
  :deep(.address-program__dropdown .p-dropdown-panel .p-dropdown-items .p-dropdown-item) {
    padding: 7.5px 10px;
  }
  &__dropdown {
    position: relative;
    width: auto !important;
    order: 3;
    top: 2px;
    :deep(.p-dropdown-trigger) {
      width: auto;
      margin-left: auto;
    }
  }
}
</style>
